import { html } from 'lit-element';

import { SimpleLitElement } from '@elab/components';

/**
 * Component display product promotions
 *
 * @author Zhynzher Oleksandr
 *
 * @attr { String }  [image-url] - url to product promotion image
 * @attr { String }  [alt-text] - alt text of promotion image
 *
 * HTML Structure Example
 *
 * <e2-wishlist-product-promotion
 *      image-url="Promotion image URL"
 *      alt-text="Promotion image alt text"
 * </e2-wishlist-product-promotion>
 * */

export class WishlistProductPromotion extends SimpleLitElement {
    static get properties() {
        return {
            imageUrl: { type: String, attribute: 'image-url' },
            altText: { type: String, attribute: 'alt-text' },
        };
    }

    render() {
        return html`
            <div class="promotion">
                <img class="promotion__image" alt="${this.altText}" src="${this.imageUrl}" />
            </div>
        `;
    }
}

export default () =>
    customElements.define('e2-wishlist-product-promotion', WishlistProductPromotion);
